<template>

<div>

    <div  v-html="svgStr">

    </div>

</div>



</template>
<script>



export default {
  name: 'AjaxSVG',
  components : {
  },
  data () {
    return {

    }
  },
  methods : {

  },
  props :['svgSrc'],

    computed : {
        svgs (){
            return this.$store.getters.svgCache
        },
        svgStr(){
            const key = btoa(this.svgSrc);
            return this.svgs[key]
        }
    },
    created(){
        const key = btoa(this.svgSrc)

      if (typeof (this.svgs[key]) === 'undefined' ){
          this.$store.dispatch('reqSVG', {url:btoa(this.svgSrc)})
      }
    }

}
</script>

<style scoped lang="scss">
    div {height: 100%;}
    svg {height: 100%}
</style>



// WEBPACK FOOTER //
// src/components/AjaxSvgVuex.vue